// xuat excel
import { getAccessToken } from "@/utils/auth"


export default {
  data() {
    return {
      isLoadLinkDownload2: false,
      downloadStorage2: null,
    };
  },
  mounted() {
    this.downloadStorage2 =  JSON.parse(localStorage.getItem(this.localStorageKeyFordownloadStorage2)) ?? null
    this.checkLinkDowload2()
  },
  methods: {
    getTimeLeftSeconds2(timeOut) {
      return Math.floor((timeOut - Date.now())/1000)
    },
    clickCheckLinkDowload2(){
      if(this.downloadStorage2){
        const {timeOut} = this.downloadStorage2
        const timeLeftSeconds = this.getTimeLeftSeconds2(timeOut)
        if(this.downloadStorage2.downloadKey){
          if(timeLeftSeconds <= 0) {
            window.open(this.downloadStorage2.linkDownload, "_blank")
            this.isLoadLinkDownload2 = false
            setTimeout(() => {
              this.downloadStorage2 = null
              localStorage.removeItem(this.localStorageKeyFordownloadStorage2)
            }, 1000)
          } else {
            let _time = this.getTimeOut2(timeLeftSeconds)
            this.$message.success('Bạn vui lòng chờ: ' + _time + '. Rồi thử lại để tải tệp')
          }
        }
      }
    },
    checkLinkDowload2(){
      if(this.downloadStorage2 && this.downloadStorage2 != null) {
        if(this.downloadStorage2.downloadKey){
          const timeLeftSeconds = this.getTimeLeftSeconds2(this.downloadStorage2.timeOut)
          this.isLoadLinkDownload2 = true
          setTimeout(() => {
            if(this?.isLoadLinkDownload2) {
              this.isLoadLinkDownload2 = false
            }
          }, timeLeftSeconds*1000);
        }
      }
    },
    clickExportDataMixin2(returnLinkData, api) {
      const token = getAccessToken()
      const linkDownload = process.env.VUE_APP_GATEWAY_API_URL + api + returnLinkData.downloadKey+'?token='+token
      const result = {...returnLinkData, timeOut: returnLinkData.waitTimeInSecs*1000 + Date.now(), linkDownload}
      this.downloadStorage2 = result
      this.checkLinkDowload2()
      let _time = this.getTimeOut2(returnLinkData.waitTimeInSecs)
      this.$message.success('Bạn vui lòng chờ: ' + _time + '. Rồi thử lại để tải tệp')
    },
    getTimeOut2(second) {
      let _time = ''
        if(second > 60){
          _time = Math.ceil(second / 60) + ' phút'
        }else{
          _time = second + ' giây'
        }
      return _time
    },
  },
  watch: {
    downloadStorage2: {
      handler(val) {
        if(val) {
          localStorage.setItem(this.localStorageKeyFordownloadStorage2, JSON.stringify(val))
        }
      },
      deep: true,
      immediate: true
    },
  },
};
